import { render, staticRenderFns } from "./DetailDeliveryReturn.vue?vue&type=template&id=8ae831c2&scoped=true&"
import script from "./DetailDeliveryReturn.vue?vue&type=script&lang=js&"
export * from "./DetailDeliveryReturn.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeliveryReturn.vue?vue&type=style&index=0&id=8ae831c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae831c2",
  null
  
)

export default component.exports